import getLocalString from "constants/Localization";
import { useGetReportTimeEntriesMutation } from "generated/graphql";

import useBitumioMutation from "hooks/useBitumioMutation";

const useGetReportTimeEntries = () => {
  const [mutation, { loading, data, error }] = useGetReportTimeEntriesMutation();
  const [getReportTimeEntries, context] = useBitumioMutation(
    {
      mutation,
      loading,
      data,
      error,
      key: "getReportTimeEntries",
    },
    {
      successMessage: getLocalString("organization.generate-report-success"),
      failureMessage: getLocalString("organization.generate-report-failure"),
    }
  );

  return [getReportTimeEntries, { ...context, data }] as const;
};

export default useGetReportTimeEntries;
